<template>
    <projectUpdateSetup v-model:dialog="dialog" :data="data" @update:dialog="dialog = $event" />
    <progressTemplateUpdateSetup v-model:dialog="progressDialog" :data="data" @update:dialog="progressDialog = $event" />
    <v-app>
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-card class="mt-0 elevation-1 rounded-lg">
                        <v-card-title class="d-flex align-center py-2 px-4 bg-blue-grey-lighten-5"
                            style="font-size: 1.1rem;">
                            <v-icon color="primary" size="small" class="mr-2">mdi-account-multiple</v-icon>
                            <span class="font-weight-medium text-primary">Project Detail - {{ project.code }}</span>
                        </v-card-title>

                        <v-divider></v-divider>

                        <v-card-text>
                            <v-row>
                                <v-col cols="4">
                                    <v-card-title class="text-h6 font-weight-bold">
                                        <v-icon left>mdi-domain</v-icon> Project Information 
                                    </v-card-title>
                                    <v-card-text>
                                        <p><strong>Project Title:</strong> {{ project.project_title }}</p>
                                        <p><strong>Amount:</strong> {{ project.agreed_amount }}</p>
                                        <p><strong>Paid Amount:</strong> {{ project.paid_amount }}</p>
                                        <p><strong>Due Amount:</strong> {{ project.due_amount }}</p>
                                        <p><strong>Project Date:</strong> {{ project.project_date }}</p>
                                        <p><strong>Project Address:</strong> {{ project.address }}</p>
                                    </v-card-text>
                                </v-col>

                                <v-col cols="4">
                                    <v-card-title class="text-h6 font-weight-bold">
                                    </v-card-title>
                                    <v-card-text>
                                        <p><strong>Start Date:</strong> {{ project.start_date }}</p>
                                        <p><strong>End Date:</strong> {{ project.end_date }}</p>
                                        <p><strong>Approval Reference:</strong> {{ project.approval_ref }}</p>
                                        <p><strong>Contacted by:</strong> {{ project.contacted_by }}</p>
                                        <p><strong>Description:</strong> {{ project.description }}</p>
                                        <p><strong>Expense Limit:</strong> {{ project.expense_limit }}</p>
                                        <p><strong>Google Link:</strong> {{ project.google_link }}</p>
                                    </v-card-text>
                                </v-col>    

                                <v-col cols="4">
                                    <v-card-title class="text-h6 font-weight-bold">
                                    </v-card-title>
                                    <v-card-text>
                                        <p><strong>Project Type:</strong> {{ project.project_type?.name }}</p>
                                        <p><strong>Remarks:</strong> {{ project.remarks}}</p>
                                    </v-card-text>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            
             <v-row>
                <v-col>
                    <div class="d-flex justify-end">
                        <v-btn v-if="tab !== 1 && tab !== 2"
                            @click="dailyUpdate(project)"
                            color="primary" 
                            variant="tonal"
                            prepend-icon="mdi mdi-plus" 
                            rounded="xl">
                            {{addButtonText}}
                        </v-btn>

                        <v-btn v-if="tab !== 1 && tab !== 3"
                            @click="projectProgressUpdate(project)"
                            color="primary" 
                            variant="tonal"
                            prepend-icon="mdi mdi-plus"
                            rounded="xl">
                            {{addButtonText}}
                        </v-btn>
                    </div>
                </v-col>
            </v-row>
    
            <v-row>
                <v-col>
                    <v-card class="elevation-2">
                        <v-tabs v-model="tab" align-tabs="center" color="primary">
                            <v-tab :value="1">Payments</v-tab>
                            <v-tab :value="2">Project Progress</v-tab>
                            <v-tab :value="3">Activity Log</v-tab>
                        </v-tabs>
                        <v-divider></v-divider>

                        <v-tabs-window v-model="tab">
                                <!-- Profile Tab -->
                                <v-tabs-window-item :value="1">
                                    <v-container fluid>
                                        <v-row dense>
                                            <v-col cols="12" md="12">
                                                <v-data-table
                                                    :headers="headers"
                                                    :items="project.project_payments"
                                                    :loading="loading"
                                                    v-model:items-per-page="itemsPerPage"
                                                    :search="search"
                                                    :hover="true"
                                                    density="compact"
                                                    hide-default-footer
                                                    show-expand
                                                    item-key="id"
                                                    class="elevation-1"
                                                    >
                                                    <template v-slot:item.index="{ index }">
                                                        {{ ++index }}
                                                    </template>
                                                    <template v-slot:item.payment_type="{ item }">
                                                        <v-chip color="success" size="small">{{ item.payment_type == 'installment'? 'Installment' : 'One Time' }}</v-chip>
                                                    </template>
                                                    <template v-slot:expanded-row="{ item, columns }">
                                                        <tr>
                                                            <td :colspan="columns.length">
                                                                <v-card flat class="ma-2 pa-2 rounded" color="grey-lighten-4">
                                                                    <div class="text-subtitle-2 text-center text-decoration-underline mb-2">Installments</div>
                                                                    <v-data-table
                                                                        :headers="detailHeaders"
                                                                        :items="item.payments"
                                                                        density="compact"
                                                                        class="elevation-1 pa-2 rounded"
                                                                        hide-default-footer
                                                                    >
                                                                    <!-- Sl -->
                                                                    <template v-slot:item.index="{ index }">
                                                                        {{ ++index }}
                                                                    </template>
                                                                    <template v-slot:item.date_of_enroll="{ item }">
                                                                        {{ item.date_of_enroll != null ? formatDateView(item.date_of_enroll) : ' --- '  }}
                                                                    </template>
                                                                    <template v-slot:item.change_date="{ item }">
                                                                        {{ item.change_date ? formatDateView(item.change_date) : ' --- ' }}
                                                                    </template>
                                                                    <template v-slot:item.recive_date="{ item }">
                                                                        {{ item.recive_date ?  formatDateView(item.recive_date) : ' --- '}}
                                                                    </template>
                                                                    <template v-slot:item.recive_amount="{ item }">
                                                                        {{ item.recive_date ?  item.recive_amount : ' --- '}}
                                                                    </template>
                                            
                                                                </v-data-table>
                                                                </v-card>
                                                            </td>
                                                        </tr>
                                                    </template>

                                                    <template #tfoot>
                                                        <tr class="bg-blue-grey-lighten-4 font-weight-bold">
                                                            <td colspan="4" class="text-center font-weight-bold"> </td>
                                                            <td colspan="2" class="text-left font-weight-bold">
                                                                Amount: {{ $numberFormat(project.project_payments.reduce((s, so) => +s + (+so.agreed_amount || 0), 0)) }}
                                                            </td>
                                                            <td colspan="2" class="text-left font-weight-bold">
                                                                Paid: {{ $numberFormat(project.project_payments.reduce((s, so) => +s + (+so.paid_amount || 0), 0)) }}
                                                            </td>
                                                            <td colspan="2" class="text-left font-weight-bold">
                                                                Due: {{ $numberFormat(project.project_payments.reduce((s, so) => +s + (+so.due_amount || 0), 0)) }}
                                                            </td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                        </tr>
                                                    </template>
                                                </v-data-table>
                                                <!-- <v-table density="comfortable" class="pa-2 elevation-1 rounded-lg" hover>
                                                    <thead>
                                                    <tr>
                                                        <th>SL</th>
                                                        <th>Author Name</th>
                                                        <th>Phone</th>
                                                        <th>Email</th>
                                                        <th>Payment Type</th>
                                                        <th>Enroll Date</th>
                                                        <th>Amount</th>
                                                        <th>Recived Amount</th>
                                                        <th>Due Amount</th>
                                                        <th>Bio</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                        <template v-for="(item, index) in project.project_payments" :key="item.id">
                                                            <tr>
                                                                <td>{{ index + 1 }}</td>
                                                                <td>{{ item.name }}</td>
                                                                <td>{{ item.phone }}</td>
                                                                <td>{{ item.email }}</td>
                                                                <td>{{  item.payment_type == 'installment' ? 'Installment' : 'One Time' }}</td>
                                                                <td>{{ $numberFormat(item.agreed_amount) }}</td>
                                                                <td>{{ $numberFormat(item.paid_amount) }}</td>
                                                                <td>{{ $numberFormat(item.due_amount) }}</td>
                                                                <td>{{ $item?.bio }}</td>
                                                            </tr>
                                                            <tr v-for="(pay, idx) in item.payments" :key="pay.id" class="bg-grey-lighten-4">
                                                                <td colspan="2">Installment: {{ idx + 1 }}</td>
                                                                <td colspan="2">Payment Date: {{ pay.payment_date }}</td>
                                                                <td>Amount: {{ $numberFormat(pay.amount) }}</td>
                                                                <td colspan="2">Received Amount: {{ $numberFormat(pay.recive_amount) }}</td>
                                                                <td colspan="2">Change Date: {{ pay.change_date }}</td>
                                                                <td colspan="2">Received Date: {{ pay.recive_date }}</td>
                                                            </tr>
                                                            <tr v-if="!project.project_payments.length">
                                                                <td colspan="7" class="text-center">
                                                                <h3>No Schedule added</h3>
                                                                </td>
                                                            </tr>
                                                        </template>
                                                    </tbody>
                                                    <tfoot>
                                                    <tr>
                                                        <td class="text-right font-weight-bold">
                                                        Total:
                                                        </td>
                                                        <td class="font-weight-bold">
                                                        {{ project.project_payments.reduce((prev, curr) => {
                                                            return +prev + curr.aggrement_amount
                                                            }, 0) 
                                                        }}
                                                        </td>
                                                        <td class="text-right font-weight-bold">
                                                        Recived Amount:
                                                        </td>
                                                        <td class="font-weight-bold">
                                                        {{ $numberFormat(getTotalReciveAmount) }}
                                                        </td>
                                                        <td class="text-right font-weight-bold">
                                                        Due Amount:
                                                        </td>
                                                        <td class="font-weight-bold">
                                                        {{ $numberFormat(getDueAmount) }}
                                                        </td>
                                                    </tr>
                                                    </tfoot>
                                                </v-table> -->
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-tabs-window-item>

                                <!-- Activity Log Tab -->
                                <v-tabs-window-item :value="2">
                                <v-container fluid>
                                    <v-card class="pa-4 elevation-1">
                                    <v-card-title class="text-h6 font-weight-bold text-primary">
                                        <v-icon left>mdi-progress-pencil</v-icon> Project Progress
                                    </v-card-title>
                                    <v-divider></v-divider>
                                    <v-card-text>
                                        <v-table density="compact">
                                            <thead>
                                            <tr>
                                                <th style="width: 7%">Sl#</th>
                                                <th style="width: 30%">Task Name</th>
                                                <th style="width: 15%">Weight Percent(%)</th>
                                                <th>Progress (%)</th>
                                                <th>Start Date</th>
                                                <th>End Date</th>
                                                <th style="width: 5%">Action</th>
                                            </tr>
                                            </thead>

                                            <tbody>
                                                <tr v-for="(item, index) in projectProgress" :key="item.id">
                                                    <td>{{ index + 1 }}</td>
                                                    <td>{{ item.task_name }}</td>
                                                    <td>{{ parseFloat(item.weight_percent).toFixed(2) }}</td>
                                                    <td style="width: 200px">
                                                    <v-text-field
                                                        v-model.number="item.progress_percent"
                                                        type="number"
                                                        min="0"
                                                        max="100"
                                                        density="compact"
                                                        hide-details
                                                    />
                                                    </td>
                                                    <td>{{ item.actual_start_date ?? '-' }}</td>
                                                    <td>{{ item.actual_end_date ?? '-' }}</td>
                                                    <td>
                                                    <v-btn
                                                        size="small"
                                                        color="success"
                                                        @click="updateProgress(item)"
                                                    >
                                                        Save
                                                    </v-btn>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </v-table>
                                    </v-card-text>

                                    <v-divider />

                                    <v-card-actions>
                                        <v-spacer />
                                        <div class="text-subtitle-1 font-weight-bold">
                                            Overall Progress: {{ overallProgress }} %
                                        </div>
                                        </v-card-actions>
                                    </v-card>
                                </v-container>
                                </v-tabs-window-item>

                                <v-tabs-window-item :value="3">
                                <v-container fluid>
                                    <v-card class="pa-4 elevation-1">
                                    <v-card-title class="text-h6 font-weight-bold text-primary">
                                        <v-icon left>mdi-history</v-icon> Activity Log
                                    </v-card-title>
                                    <v-divider></v-divider>
                                    <v-card-text>
                                        <v-timeline v-for="(activity, index) in projectActivity" 
                                            :key="index"  align="center" density="compact">
                                        <v-timeline-item size="small" color="deep-purple">
                                            <v-card class="pa-3" cols="12">
                                            <div class="d-flex align-center">
                                                <v-avatar
                                                icon="$vuetify"
                                                :image="
                                                getFileServerUrl +
                                                (activity.created_by.image_thumb != null
                                                    ? activity.created_by.image_thumb
                                                    : 'uploads/demo_images/user.png')
                                                "
                                                size="40"
                                                ></v-avatar>
                                                <v-col>
                                                <h3>{{ activity.created_by.full_name }}</h3>
                                                <p>{{ (new Date(activity.created_at)).toISOString().slice(0, 19).replace("T", " ") }}</p>
                                                </v-col>
                                            </div>
                                            <p class="synopsis-text"><strong>Description:</strong> {{ activity.description }}</p>
                                            <!-- <v-row class="pa-3 align-center">
                                                <v-col class="d-flex ga-1">
                                                    <v-chip class=" bg-brown-lighten-4 text-brown-darken-4 font-weight-bold">{{ activity.project_activity.name }}</v-chip>
                                                    <v-chip class="bg-yellow-lighten-1 text-yellow-darken-4 font-weight-bold">{{ activity.project_sub_activity.name }}</v-chip>
                                                </v-col>
                                            </v-row> -->
                                            <!-- <v-divider></v-divider>
                                                <p class="mt-2"><strong>Next follow-up date:</strong>
                                                    {{ (new Date(activity.date)).toISOString().slice(0, 19).replace("T", " ") }}
                                                </p> -->
                                            </v-card>
                                        </v-timeline-item>
                                        </v-timeline>
                                    </v-card-text>
                                    </v-card>
                                </v-container>
                                </v-tabs-window-item>
                        </v-tabs-window>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>


<script>
import { useStore } from 'vuex';
import { ref } from 'vue';
import { toast } from 'vue3-toastify';
import { useRouter } from 'vue-router';
import projectUpdateSetup from "@/components/module/project/projectManagement/projectUpdateSetup.vue";
import progressTemplateUpdateSetup from "@/components/module/project/projectManagement/progressTemplateUpdateSetup.vue";
import axios from 'axios';
import { baseURL } from '@/store/api';
import { formatDateView, formatDateDash } from "@/plugins/helpers";

export default {
    name: 'LeadView',
    components: {
        projectUpdateSetup,
        progressTemplateUpdateSetup,
    },
    data: () => (
        {
            id: "",
            tab: 1,
            addButtonText: "",  
            leadView: [],
            project: {
                project_id: '',
                code: '',
                project_title: '',
                approval_ref: '',
                agreed_amount: '',
                paid_amount: '',
                expense_limit: '',
                due_amount: '',
                project_date: '',
                contacted_by: '',
                remarks: '',
                description: '',
                start_date: '',
                end_date: '',
                project_type: '',
                project_theme: '',
                address: '',
                donor_name: '',
                expense_limit: '',
                google_link: '',
                whatsapp_link: '',
                project_payments: []

            },
            projectActivity: [],
            projectProgress: [],
            leadAssigned: [],
            overallProgress: '',
            isLoading: false,
            data: {},
            headers: [
                { title: "SL", align: "center", key: "index", width: "7%", sortable: false,},
                { title: "Project Payment Code", align: "center", key: "code", sortable: false,},
                { title: "Payment Method", key: "payment_method", align: "left", sortable: true,},
                { title: "Payment Type", key: "payment_type", align: "left", sortable: true,},
                { title: "Payment Date", key: "date_of_enroll", align: "left", sortable: true,},
                { title: "Amount", align: "center", key: "agreed_amount", sortable: true },
                { title: "Received Amount", align: "center", key: "paid_amount", sortable: false },
                { title: "Due Amount", align: "center", key: "due_amount", sortable: false },
                { title: "Bio", align: "center", key: "bio", sortable: false },
                { title: "Next Payment Date", key: "next_payment_date", align: "left", sortable: true,},
                { title: "Cheque No", key: "chequeNo", align: "left", sortable: true,},
                { title: "Cheque Issue Date", key: "cheque_issue_date", align: "left", sortable: true,},
                { title: "Installments", key: "install_ments", align: "left", sortable: true,},
            ],
            detailHeaders: [
                { title: 'SL', align: "center", key: 'index', width: "7%",},
                { title: 'Payment Date', align: "center", key: 'payment_date' },
                { title: 'Changed Date', align: "center", key: 'change_date' },
                { title: 'Received Date', align: "center", key: 'recive_date' },
                { title: 'Amount', align: "center", key: 'amount' },
                { title: 'Received Amount', align: "center", key: 'recive_amount' },
            ],
            dialog: false,
            progressDialog: false,
        }
    ),
    watch: {
        tab: async function (val) {
            if (val === 3) {
                this.addButtonText = "Add Daily Update"
                if (this.projectActivity.length > 0) return;
                else {
                    this.projectActivity = await this.$store.dispatch("getProjectActivityLogById", this.id)
                    .then((response) => {
                        console.log(response)
                        return response;
                    })
                }
            } else if (val === 2) {
                this.addButtonText = "Project Progress"
                if (this.projectProgress.length > 0) return;
                else {
                    this.projectProgress = await this.$store.dispatch("getProgressList", this.id)
                    .then((response) => {
                        return response;
                    })
                }
                this.overallProgress = await this.$store.dispatch("getProgressSummary", this.id)
                        .then((response) => {
                            return response;
                        })
            }
        },

        leadView: function (val, oldval) {
            console.log("new leadview", val);
            console.log("old leadview", oldval);
        },
        leadAssigned: function (val, oldval) {
            console.log("new leadAssigned", val);
            console.log("old leadAssigned", oldval);
        },
        projectActivity: function (val, oldval) {
            console.log("new lead activity", val);
            console.log("old lead activity", oldval);
        }
    },
    computed: {
        getFileServerUrl() {
            return this.$store.getters.getFileServerUrl;
        },
        getProjectActivityLogById() {
            this.projectActivity = this.$store.dispatch("getProjectActivityLogById", this.id)
        },
        getProgressList() {
            this.projectProgress = this.$store.dispatch("getProgressList", this.id)
        },
        getProgressTemplateList() {
            let data = this.$store.getters.getProgressTemplateList;
            if (data.length > 0) {
                return data.filter((item) => item.status == 1);
            }
            return [];
        },
    },
    created() {
        this.leadView = []
        this.leadAssigned = []
        this.leadActivity = []
        if (this.$store.getters.getProgressTemplateList.length == 0) {
            this.$store.dispatch("getProgressTemplateList");
        }
    },
    methods: {
        formatDateView,
        dailyUpdate(item) {
            this.data = { ...item };
            this.dialog = true;
        },
        projectProgressUpdate(item) {
            this.data = { ...item };
            this.progressDialog = true;
        },
        async updateProgress(item) {
            await axios.put(`${baseURL}/api/auth/project/update-project-progress/${item.id}`, {
                progress_percent: item.progress_percent
            }).then(async (response) => {
                toast.success("Progress updated successfully");

                this.projectProgress = await this.$store.dispatch("getProgressList", this.id)
                    .then((resp) => {
                        return resp;
                    });

                this.overallProgress = await this.$store.dispatch("getProgressSummary", this.id)
                    .then((resp1) => {
                        return resp1;
                    });
            }).catch((error) => {
                toast.error("Failed to update progress");
                console.error("Error updating progress:", error);
            });
        },
    },
    mounted() {
        // console.log(this.leadView)
        this.id = this.$route.params.id || "";

        const id = this.$route.params.id;
        if (id) {
            this.$store.commit('SET_LOADING', { color: 'primary' });

            this.$nextTick(() => {
                this.$store.dispatch('getProjectListById', id)
                    .then((data) => {
                        this.isEntryMode = false;
                        let project = data;
                        this.project.project_id = project.id;
                        this.project.code = project.code;
                        this.project.project_title = project.project_title;
                        this.project.agreed_amount = project.agreed_amount;
                        this.project.paid_amount = project.paid_amount;
                        this.project.approval_ref = project.approval_ref;
                        this.project.due_amount = project.due_amount;
                        this.project.project_date = project.project_date;
                        this.project.contacted_by = project.contacted_by.name;
                        this.project.description = project.description;
                        this.project.start_date = project.start_date;
                        this.project.end_date = project.end_date;
                        this.project.project_type = project.project_type;
                        this.project.project_theme = project.project_theme;
                        this.project.registration_type = project.registration_type == 1 ? 'Open' : 'Closed';
                        this.project.address = project.address;
                        this.project.donor_name = project.donor_name;
                        this.project.expense_limit = project.expense_limit;
                        this.project.remarks = project.remarks;
                        this.project.google_link = project.google_link;
                        this.project.whatsapp_link = project.whatsapp_link;
                        this.project.remarks = project.remarks ? rfq.remarks : '';
                        this.project.project_payments = project.project_payments;
                        console.log(this.project);
                        this.$store.commit('UNSET_LOADING');
                    })
                    .catch((error) => {
                        this.$store.commit('UNSET_LOADING');
                        console.error("Failed to fetch rfq:", error);
                    });
            });
        } else {
            // this.rfq_master_id.value.value = '';
            // this.rfq_date.value.value = new Date();
            // this.require_date.value.value = new Date();
            this.isEntryMode = true;
        }
    }
}
</script>

<style scoped>
.position-relative {
    position: relative;
}

.checkbox-position {
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 1;
}

.synopsis-text {
    white-space: normal;
    word-wrap: break-word;
    overflow-wrap: anywhere;
}
.v-data-table tfoot td {
  padding-top: 12px;
  padding-bottom: 12px;
}
</style>
